import { CountryInfo } from "../countries/countries.types";

export const $VatPrefixesModuleName = "vatPrefixes";

export type VatPrefixInfo = {
    country: CountryInfo;
    prefix: string;
};

export type TVatPrefixesState = {
    prefixes: Array<VatPrefixInfo>;
};
